'use client';

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import { tv } from 'tailwind-variants';
import { faCheck, faMinus } from '@icons/classic/regular';
const checkbox = tv({
  base: `
    peer
    border-input
    dark:bg-input/30
    data-[state=checked]:bg-primary
    data-[state=checked]:text-primary-foreground
    dark:data-[state=checked]:bg-primary
    data-[state=checked]:border-primary
    aria-invalid:ring-destructive/20
    dark:aria-invalid:ring-destructive/40
    aria-invalid:border-destructive
    focus-visible:ring-content-primary
    disabled:!bg-background-disabled
    disabled:!border-input
    disabled:data-[state=checked]:[&_[data-slot=radio-group-indicator]]:bg-background-disabled
    size-4
    shrink-0
    rounded-[4px]
    border
    shadow-xs
    transition-shadow
    outline-none
    focus-visible:ring-1
    focus-visible:ring-offset-1
    data-[state=unchecked]:[&_[data-slot=checkbox-indicator]]:hidden
    enabled:cursor-pointer
    `
});
type CheckboxProps = React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  indeterminate?: boolean;
};
function Checkbox(t0) {
  const $ = _c(14);
  let checked;
  let className;
  let indeterminate;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      indeterminate,
      checked,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = className;
    $[3] = indeterminate;
    $[4] = props;
  } else {
    checked = $[1];
    className = $[2];
    indeterminate = $[3];
    props = $[4];
  }
  const checkedValue = indeterminate ? "indeterminate" : checked;
  let t1;
  if ($[5] !== className) {
    t1 = checkbox({
      className
    });
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = indeterminate ? faMinus : faCheck;
  let t3;
  if ($[7] !== t2) {
    t3 = <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current transition-none" data-slot="checkbox-indicator"><FontAwesomeIcon className="size-2.5" icon={t2} /></CheckboxPrimitive.Indicator>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== checkedValue || $[10] !== props || $[11] !== t1 || $[12] !== t3) {
    t4 = <CheckboxPrimitive.Root className={t1} checked={checkedValue} data-slot="checkbox" {...props}>{t3}</CheckboxPrimitive.Root>;
    $[9] = checkedValue;
    $[10] = props;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export { Checkbox };